/**
 * Capacitor shell bootstrap (no-op on plain web).
 * Call once at app entry so status bar / splash behave on device.
 */

import { isNativeApp } from './utils/platform'

export async function bootstrapNativeShell() {
  if (!isNativeApp()) return

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar')
    await StatusBar.setStyle({ style: Style.Dark })
  } catch (e) {
    console.warn('nativeBootstrap StatusBar:', e?.message || e)
  }

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen')
    await SplashScreen.hide()
  } catch (e) {
    console.warn('nativeBootstrap SplashScreen:', e?.message || e)
  }

  try {
    const { App } = await import('@capacitor/app')
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) window.history.back()
      else App.exitApp()
    })
  } catch (e) {
    console.warn('nativeBootstrap App:', e?.message || e)
  }
}
